<template>
  <div class="containerTable" style="padding: 15px;">
    <vxe-toolbar
      id="toolbarId_fa9"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('payable_search_button')" @click="funcFilter"
          >查询</el-button
        >
        <!-- <el-button @click="funcAdd">新增</el-button> -->
        <el-date-picker
          v-model="listQuery.reptdtRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'reptdt')"
        />
        <el-button v-if="getLimit('payable_export_button')" @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      :show-footer="true"
      :footer-method="footerMethod"
      :loading="loading"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createMonth"
          title="月份"
          min-width="100"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userName"
          title="客户名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userName"
            placeholder="请输入客户名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="userPhone"
          title="手机号码"
          min-width="140"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.userPhone"
            placeholder="请输入手机号码"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="startBalance"
          title="期初余额"
          min-width="100"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shouldBalance"
          title="应付金额"
          min-width="100"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="alreadyBalance"
          title="已付金额"
          min-width="100"
          sortable
        />
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="endBalance"
          title="期末金额"
          min-width="100"
          sortable
        />
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import request from "@/utils/request";
export default {
  name: "PartyList",
  components: {},
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      copy: false,
      alreadyBalance: "",
      shouldBalance: "",
      exportObj: {
        exportUrl: "/ntocc-tms-api/statistics/exportSumPayLedger", //导出接口
        name: "应付总账"
      },
      listQuery: {
        reptdtRange: [],
        code: "", // code编码
        userCode: "", // 用户编码(托运人或实际承运人)
        userName: "", // 客户名称
        userPhone: "", // 客户电话
        reptdt: "", // 统计时间
        reptdtStart: "", // 统计时间开始
        reptdtEnd: "", // 统计时间结束
        startBalance: "", // 期初余额
        shouldBalance: "", // 应收金额或应付金额
        alreadyBalance: "", // 已收金额或已付金额
        endBalance: "", // 期末余额
        type: 1, // 0 应收 1应付
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      roleList: [],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "ntocc-tms-api/statistics/getSumReceiveLedgerList",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.shouldBalance = response.data.sumObject.shouldBalance;
          this.alreadyBalance = response.data.sumObject.alreadyBalance;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 底部颜色设置
    /*     footerCellClassName({ $rowIndex, column, columnIndex }) {
        if (columnIndex === 0) {
          if ($rowIndex === 0) {
            return 'col-blue'
          } else {
            return 'col-red'
          }
        }
      }, */
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "shouldBalance") {
            // 冻结金额
            return this.shouldBalance;
          }
          if (column.property === "alreadyBalance") {
            // 账户金额
            return this.alreadyBalance;
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>
<style></style>
